// 'home' | 'away' | null
export function getUserTeam(game, username) {
  if (game.player1?.name === username || game.player2?.name === username) return 'home';
  if (game.player3?.name === username || game.player4?.name === username) return 'away';
  return null;
}

// { user, teammate, opp1, opp2 } — user always listed first on their side
export function getDisplayPlayers(game, username, userTeam) {
  if (userTeam === 'home') {
    const user     = game.player1?.name === username ? game.player1 : game.player2;
    const teammate = game.player1?.name === username ? game.player2 : game.player1;
    return { user, teammate, opp1: game.player3, opp2: game.player4 };
  }
  const user     = game.player3?.name === username ? game.player3 : game.player4;
  const teammate = game.player3?.name === username ? game.player4 : game.player3;
  return { user, teammate, opp1: game.player1, opp2: game.player2 };
}

// boolean — did username's team win?
export function isUserWin(game, username) {
  const userTeam = getUserTeam(game, username) ?? 'home';
  const s1 = parseFloat(game.scores?.score1 || 0);
  const s2 = parseFloat(game.scores?.score2 || 0);
  return userTeam === 'home' ? s1 > s2 : s2 > s1;
}

// { userScore, oppScore }
export function getUserScores(game, username) {
  const userTeam = getUserTeam(game, username) ?? 'home';
  const s1 = game.scores?.score1 ?? 0;
  const s2 = game.scores?.score2 ?? 0;
  return userTeam === 'home' ? { userScore: s1, oppScore: s2 } : { userScore: s2, oppScore: s1 };
}
